exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Table1 .table{display:table;border-collapse:collapse;width:100%}.Table1 .td,.Table1 .th{border:1px solid #999;text-align:center;font-size:1em;font-weight:400}.Table1 a{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/Table1/Table1.scss
// module id = 1176
// module chunks = 32